import React, { useEffect, useState, PropsWithChildren } from "react";
import S from './MainHero.styled';

import { useHeroReportData } from "./useHeroReportsData";
import { useHeroArticlesData } from "./useHeroArticlesData";

import StickyButton from "./StickyButton";

import ExternalLinkArrow from "@/src/images/ExternalLinkArrow.png";
import ExternalLinkArrowActive from "@/src/images/ExternalLinkArrowActive.png";
import ExpandArrow from "@/src/images/ExpandArrow.png";
import ExpandArrowWhite from "@/src/images/ExpandArrowWhite.png";

import { graphql, useStaticQuery } from "gatsby";

type Props = {
    heroButtonColor?: string;
    sticky: {
        content: string;
        title: string;
        color: string;
    };
};

export type IEvent = {
    title: string;
    location: string;
    description: string;
    registration_url: string;
    information_url: string;
    datetime_from: string;
    datetime_to: string;
    is_invite_only: boolean;
};

export type EventProps = {
    allPortalEvent?: {
        nodes: IEvent[];
    } | undefined;
};

export const useEventData = () => {
    const data: EventProps = useStaticQuery(
        graphql`
      {
        allPortalEvent(filter: { id: { ne: "dummy" } }) {
          nodes {
            title
            location
            description
            registration_url
            information_url
            datetime_from
            datetime_to
            is_invite_only
          }
        }
      }
    `
    );
    return data?.allPortalEvent?.nodes;
};


type BtnProps = {
    button: {
        target: string;
        title: string;
        url: string;
    };
    title: string;
    background?: string;
    sticky?: boolean;
    mixed?: boolean;
    className?: string;
};

const StickyContentButton: React.FC<PropsWithChildren<BtnProps>> = (props) => {
    return (
        <S.StickyContentButton mixed={props.mixed} className={props.className} sticky={props.sticky} id={props.title} href={props.button.url} target={props.button.target} background={props.background} >
            <div>{props.button.title}</div>
            {props.children}
        </S.StickyContentButton>
    );
};

const StickyContent: React.FC<PropsWithChildren<Props>> = ({ sticky }) => {
    const [expandCard, setExpandCard] = useState<{}>({});

    const eventData = useEventData();
    const stickyReports = useHeroReportData();
    const stickyArticles = useHeroArticlesData();

    useEffect(() => {
        stickyArticles.map(article => setExpandCard({ [article.id]: false }))
    }, [])

    const handleClickArticle = (e: { target: { id: string }, preventDefault: () => void; }, id: string) => {
        if (e.target.id === 'read_more') {
            return;
        }
        e.preventDefault();

        if (expandCard[id]) {
            setExpandCard({ ...expandCard, [id]: false });

        } else {
            setExpandCard({ ...expandCard, [id]: true });
        }
    }

    return (
        <S.StickyGridItem>
            <S.StickyTitle>
                <S.H3Title backgroundColor={"black"} >{sticky.title}</S.H3Title>
            </S.StickyTitle>
            {sticky.content === 'event' && (eventData && eventData.map(s =>
                <S.ButtonWrapper key={s.title}>
                    <StickyContentButton
                        button={{ url: s.information_url ? s.information_url : s.registration_url, title: s.title.length > 30 ? s.title.slice(0, 30) + '...' : s.title, target: '_blank' }}
                        title={s.title}
                        background={sticky.color}
                        sticky={true}
                    >
                        <S.Img className="arrow_btn" src={ExternalLinkArrow} alt="arrow" />
                        <S.Img className="arrow_btn-active" src={ExternalLinkArrowActive} alt="arrow" />
                    </StickyContentButton>
                </S.ButtonWrapper>
            ))}
            {sticky.content === 'reports' && (stickyReports && stickyReports.map((s, i) =>
                <S.ButtonWrapper key={s.title}>
                    <StickyContentButton
                        button={{ url: s.url, title: s.title.length > 30 ? s.title.slice(0, 30) + '...' : s.title, target: '_blank' }}
                        title={s.title}
                        background={sticky.color}
                        sticky={true}
                        className={`report-${i + 1}`}
                    >
                        <S.Img className="arrow_btn" src={ExternalLinkArrow} alt="arrow" />
                        <S.Img className="arrow_btn-active" src={ExternalLinkArrowActive} alt="arrow" />
                    </StickyContentButton>
                </S.ButtonWrapper>
            ))}
            {sticky.content === 'articles' && (stickyArticles && stickyArticles.map((s, i) =>
                <S.ButtonWrapper key={s.id}>
                    <StickyButton
                        button={{ url: '', title: s.title.length > 50 ? s.title.slice(0, 50) + '...' : s.title, target: 'blank' }}
                        title={s.title}
                        background={sticky.color}
                        sticky={true}
                        expandCard={expandCard[s.id]}
                        onClick={(e: any) => handleClickArticle(e, s.id)}
                        className={`article-${i + 1}`}
                    >
                        <S.Img className="arrow_btn" src={ExpandArrowWhite} alt="arrow" />
                        <S.Img className="arrow_btn-active" src={ExpandArrow} alt="arrow" />
                        <S.Preamble className="preamble">{s.preamble}</S.Preamble>
                        <a target="_blank" id="read_more" href={s.url}>Läs mer
                            <S.Img className="arrow_btn" src={ExternalLinkArrow} alt="arrow" />
                            <S.Img className="arrow_btn-active" src={ExternalLinkArrowActive} alt="arrow" />
                        </a>
                    </StickyButton>
                </S.ButtonWrapper>
            ))}
            {sticky.content === 'mixed' &&
                <div>
                    {eventData &&
                        <S.ButtonWrapper key={eventData[0].title}>
                            <StickyContentButton
                                button={{ url: eventData[0].information_url ? eventData[0].information_url : eventData[0].registration_url, title: eventData[0].title.length > 30 ? eventData[0].title.slice(0, 30) + '...' : eventData[0].title, target: '_blank' }}
                                title={eventData[0].title}
                                background={'red'}
                                sticky={true}
                                mixed={true}
                            >
                                <S.Img className="arrow_btn" src={ExternalLinkArrow} alt="arrow" />
                                <S.Img className="arrow_btn-active" src={ExternalLinkArrowActive} alt="arrow" />
                                <S.Type className="type">Event</S.Type>
                            </StickyContentButton>
                        </S.ButtonWrapper>
                    }
                    {stickyReports &&
                        <S.ButtonWrapper key={stickyReports[0].title}>
                            <S.ButtonWrapper key={stickyReports[0].title}>
                                <StickyContentButton
                                    button={{ url: stickyReports[0].url, title: stickyReports[0].title.length > 30 ? stickyReports[0].title.slice(0, 30) + '...' : stickyReports[0].title, target: '_blank' }}
                                    title={stickyReports[0].title}
                                    background={'blue'}
                                    sticky={true}
                                    mixed={true}
                                >
                                    <S.Img className="arrow_btn" src={ExternalLinkArrow} alt="arrow" />
                                    <S.Img className="arrow_btn-active" src={ExternalLinkArrowActive} alt="arrow" />
                                    <S.Type className="type">Report</S.Type>
                                </StickyContentButton>
                            </S.ButtonWrapper>
                        </S.ButtonWrapper>
                    }
                    {stickyArticles &&
                        <S.ButtonWrapper>
                            <StickyButton
                                button={{ url: '', title: stickyArticles[0].title.length > 50 ? stickyArticles[0].title.slice(0, 50) + '...' : stickyArticles[0].title, target: 'blank' }}
                                title={stickyArticles[0].title}
                                background={'green'}
                                sticky={true}
                                mixed={true}
                                expandCard={expandCard[stickyArticles[0].id]}
                                onClick={(e: any) => handleClickArticle(e, stickyArticles[0].id)}
                                className={`article-1`}
                            >
                                <S.Img className="arrow_btn" src={ExpandArrowWhite} alt="arrow" />
                                <S.Img className="arrow_btn-active" src={ExpandArrow} alt="arrow" />
                                <S.Type className="type">Article</S.Type>
                                <S.Preamble className="preamble">{stickyArticles[0].preamble}</S.Preamble>
                                <a target="_blank" id="read_more" href={stickyArticles[0].url}>Läs mer
                                    <S.Img className="arrow_btn" src={ExternalLinkArrow} alt="arrow" />
                                    <S.Img className="arrow_btn-active" src={ExternalLinkArrowActive} alt="arrow" />
                                </a>
                            </StickyButton>
                        </S.ButtonWrapper>
                    }
                </div>
            }
        </S.StickyGridItem>
    );
};

export default StickyContent;
